import { gql } from '@apollo/client'
import React from 'react'

import { checklistsClient } from '../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../components/helpers/LazyAction'
import StatePresenter from '../../../components/helpers/StatePresenter'
import { useTranslation } from 'react-i18next'

const Context = React.createContext()
const { Provider } = Context
export const useChecklistTypesState = () => React.useContext(Context) || {}
export const useChecklistTypes = () => useChecklistTypesState()?.checklistTypes || []

const translatedChecklistTypes = (data, t) => {
  if (!data) return []
  const result = data.checklistTypes.map(checklistType => {
    return { ...checklistType, name: t(checklistType.name) }
  })
  return { checklistTypes: result }
}

const QUERY = gql`
  query ChecklistTypes($page: Int, $search: String, $filter: ChecklistTypeFilter) {
    checklistTypes(page: $page, search: $search, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
    }
  }
`

const TypesLoader = ({ children, search, uncontrolledChildren, perPage: limit, filter }) => {
  const { t } = useTranslation('common')
  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search: search || undefined,
      limit,
      filter
    },
    client: checklistsClient
  })

  return (
    <Provider value={translatedChecklistTypes(data, t)}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren} empty={false}>
        {children}
      </StatePresenter>
      <LazyAction action={fetchMore} waiting={state.loading} />
    </Provider>
  )
}

export default TypesLoader
